<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<form
  (submit)="onSubmit(form.value)"
  [formGroup]="form"
  (click)="$event.stopPropagation()"
  (keyup)="$event.stopPropagation()">
  <div class="filter-menu">
    @if (!singleFilter) {
      <mat-form-field
        class="filter-form"
        appearance="outline"
        (click)="$event.stopPropagation(); $event.preventDefault()"
        (keyup)="$event.stopPropagation(); $event.preventDefault()">
        @if (!availableFilters?.length) {
          <mat-label>{{ 'Filter Unavailable' | translate: locale.language }}</mat-label>
        } @else {
          <mat-label>{{ 'Filter.FilterBy' | translate: locale.language }} </mat-label>
        }
        <mat-select
          formControlName="field"
          [attr.data-test]="'filter-select'"
          (selectionChange)="onSelectChange($event.value)">
          @for (field of availableFilters; track field.field) {
            <mat-option [value]="field.field" [attr.data-test]="'filter-option-' + field.field">
              {{ field.localizedLabel | translate: locale.language }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @switch (selectedFilter?.type) {
      @case ('date') {
        <date-filter [control]="valueForm"></date-filter>
      }
      @case ('daterange') {
        <date-range-filter [formGroup]="dateRangeForm"></date-range-filter>
      }
      @case ('daterange-menu') {
        <date-range-filter [formGroup]="dateRangeForm"></date-range-filter>
      }
      @case ('boolean') {
        <slide-toggle-filter
          style="display: block; margin-bottom: 1rem"
          [control]="valueForm"
          [placeholder]="selectedFilter?.placeholder"></slide-toggle-filter>
      }
      @case ('tenant') {
        <app-tenant-search
          (keyup)="$event.stopPropagation(); $event.preventDefault()"
          (click)="$event.stopPropagation()"
          [useDefaultStyling]="true"
          [inputStyle]="{ width: '100%' }"
          [initialTenantId]="form.value.value?.toString()"
          (tenantSelected)="onTenantSelect($event?.id?.toString())"
          (formChange)="onTenantSelect($event)"
          (enterPressed)="onSubmit({ field: form.value.field, value: $event })">
        </app-tenant-search>
      }
      @case ('select') {
        @if (selectedFilter.values) {
          <selection-filter [control]="valueForm" [values]="selectedFilter.values"></selection-filter>
        } @else if (selectedFilter.valuesFunc) {
          <dynamic-selection-filter
            [control]="valueForm"
            [func]="selectedFilter.valuesFunc(selectedFilter.field)"
            [variables]="selectedFilter?.variables"></dynamic-selection-filter>
        }
      }
      @default {
        <mat-form-field
          class="filter-form"
          appearance="outline"
          (click)="$event.stopPropagation(); $event.preventDefault()"
          (keyup)="$event.stopPropagation(); $event.preventDefault()">
          <mat-label>
            {{ 'Filter.Value' | translate: locale.language }}
          </mat-label>
          <input matInput formControlName="value" [attr.data-test]="'filter-value'" />
        </mat-form-field>
      }
    }

    <div class="filter-buttons">
      <button
        type="submit"
        mat-raised-button
        class="filter-button"
        color="primary"
        [attr.data-test]="'filter-apply-button'"
        [disabled]="isDisabled">
        <mat-icon>add</mat-icon>
        {{ (mode === 'create' ? 'Filter.Apply' : 'Filter.Update') | translate: locale.language }}
      </button>

      @if (variables.length) {
        <button
          [disabled]="!unusedVariables.length"
          type="button"
          mat-button
          class="filter-button"
          matTooltip="A dynamic filter that references a field"
          [attr.data-test]="'filter-variables-button'"
          [matMenuTriggerFor]="variablesMenu">
          <mat-icon>lightbulb_circle</mat-icon>
          {{ 'Use Reference' | translate: locale.language }}
        </button>
      }
    </div>
  </div>
</form>

<mat-menu #variablesMenu>
  @for (variable of unusedVariables; track variable.value) {
    <button mat-menu-item (click)="addVariable($event, variable)" [matTooltip]="variable.description">
      {{ variable.label }}
    </button>
  }
</mat-menu>
